<i18n src="../../locales/lang.json"></i18n>

<template>
  <ul v-if="pages>0" class="pagination pagination-flat align-self-center" style="display:inline-flex">
    <li v-bind:class="{disabled:currentpage == 0}" class="page-item"><a  @click.prevent="selectPreviousPage()" class="page-link"  style="color:inherit">{{$t('previous')}}</a></li>
    <li v-bind:class="{'skin light-bg':item.active}" class="page-item" v-for="item in Items"><a href="#" class="page-link" @click.prevent="selectPage(item.caption - 1)" style="color:inherit">{{item.caption}}</a></li>
    <li  v-bind:class="{disabled:currentpage + 1 == pages}" class="page-item"><a @click.prevent="selectNextPage()" class="page-link"  style="color:inherit">{{$t('next')}}</a></li>
  </ul>
</template>

<script>
  var tempPageNumber = 0;
  export default {
    name: "table-pagination",
    components: {
      
    },
    props: {
      currentpage: {
        required: false,
        type: Number,
        default: 0
      },
      pages: {
        required: false,
        type: Number,
        default: 0
      },
      externalpaging: {
        required: false,
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        tempPageNumber: 0,
        perPageRecord: 0,
        totalRecods: 0,
      };
    },
    computed: {
      Items: {
        get() {
          var items = [];
          //this.pages
          for (var i = this.tempPageNumber;i>=0 && i < this.tempPageNumber+10 && i < this.pages; i++) {
            var item = {
              caption: i + 1,
              active: i == this.currentpage
            }
            items.push(item);
          }
          return items;
        },
      }
    },
    methods: {
      setPaging(currentpage, totalRecods, perPageRecord = 20) {
        if (totalRecods > perPageRecord) {
          this.currentpage = currentpage;
          this.perPageRecord = perPageRecord;
          this.totalRecods = totalRecods;
          var divide = totalRecods / perPageRecord;
          var round = Math.round(totalRecods / perPageRecord);
          if (round < divide) {
            round = round + 1;
          }

          this.pages = round;
        }
        else {
          this.pages = 0;
        }
      },
      selectPreviousPage() {        
        this.tempPageNumber = this.currentpage - 10;
        if (this.tempPageNumber < 0) {
          this.tempPageNumber = 0;
        }
        this.selectPage(this.currentpage - 1);
      },
      selectNextPage() {
        this.tempPageNumber = this.currentpage + 1;
        if (this.tempPageNumber > this.pages+1) {
          this.tempPageNumber = this.pages;
        }
        this.selectPage(this.tempPageNumber)
      },
      selectPage(page) {
        this.currentpage = page;        
        if (this.externalpaging) {
          var obj = { pagenumber: page, tablename: null };
          var data = JSON.stringify(obj);
          vm.$root.$emit('page_change', data);
          this.$emit('page_change', data);
        } else {
          this.$emit("selectpage", this.currentpage)
        }
      },
      handleRefresh(val) {
        this.$forceUpdate();
      }
    },

    mounted() {

    },

    created: function () {

    },

    watch: {
     
    },
    created() {     
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/tables/table-pagination.vue